import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { EmailPopup } from "@/components/EmailPopup";
import { CookieBanner, RouteTracker } from "@/components/CookieBanner";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  const isAdmin = ["/admin", "/sign-", "/account", "/subscribe", "/payment"].some((x) => pathname.startsWith(x));
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<div className="min-h-[60vh]" />}><Outlet /></Suspense>
      </main>
      <Footer />
      <CartDrawer />
      <CookieBanner />
      <RouteTracker />
      {!isAdmin && <EmailPopup />}
    </div>
  );
};
